var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticClass:"pa-4"},[_c('PageHeader',{attrs:{"sub-title":_vm.__('company.components.courses.video-dialog.title')}}),_c('div',{staticClass:"d-flex justify-center",attrs:{"id":"player"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }